import { CreditTabType } from "@/store/credit/credit.atoms";
import { Tab } from "@ir/ui";
import { memo } from "react";

const CreditInformationTab = () => {
  return (
    <Tab id={CreditTabType.INFORMATION} aria-label={CreditTabType.INFORMATION} title={CreditTabType.INFORMATION}>
      {CreditTabType.INFORMATION}
    </Tab>
  );
};

CreditInformationTab.displayName = "CreditInformationTab";

export default memo(CreditInformationTab);
